<template lang="html">
    <div>
       <h2 class="text-sm font-medium" v-show="showLabel">Sound reactions </h2>
       <div class="grid gap-1 py-2" :class="customClass">
            <button 
            @click="playSound($event, sound)"
            class="btn btn-sm btn-secondary w-full" :class="itemsClass + ' ' + sound.color"  v-bind:style="sound.style" :id="sound.name" v-for="sound in sounds">
            <span>
              {{sound.label}}
            </span>
          </button>
        </div>
    </div>
</template>
<script>
import commandsManager from 'general/CommandsManager';

export default {
    props: {
      showLabel: {
        type: Boolean,
        required: false,
        default: false
      },
      customClass: {
        type: String,
        required: false,
        default: 'grid-cols-6'
      },
      itemsClass: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        sounds: [
          {
            name: 'sound1',
            label: 'Wow',
            src: 'soundBar1'
          },
          {
            name: 'sound2',
            label: 'Yes',
            src: 'soundBar2'
          },
          {
            name: 'sound3',
            label: 'Ovation',
            src: 'soundBar3'
          },
          {
            name: 'sound4',
            label: 'Done',
            src: 'soundBar4'
          },
          {
            name: 'sound5',
            label: 'So cool',
            src: 'soundBar5'
          },
          {
            name: 'martini',
            label: 'Martini',
            color: 'bg-green-mictap text-white',
            src: 'martiniShotSound'
          }
        ]
      }
    },
    methods: {
      playSound(evt, sound){
        const soundFile = $("#"+sound.src)[0]

        let evtTarget = $(evt.currentTarget);
        if(soundFile) soundFile.play().then(() => {
          evtTarget.addClass("loading");
        })
        let playBackDuration = soundFile.duration;

        // add transitionDuration to the buttons :after selector
        evtTarget[0].style.setProperty('--animation-duration', playBackDuration + "s");

        window.setTimeout(() => {
          evtTarget.removeClass("btn-loading loading");
        }, playBackDuration * 1000);

        evtTarget.addClass("btn-loading");

        this.sounds.forEach(s => {
          s.style = { background: "linear-gradient(90deg, #1701fe 0%, #1701fe 0%, transparent)" };
        })
        commandsManager.sendAllCommand('play_soundbar', { sound });
      }
    },
    mounted(){
    }
    
}
</script>
<style lang="css">
    
</style>
